// extracted by mini-css-extract-plugin
export default {"studioSection":"JaymarStudioSection_studioSection__Wpd5R"};